<nav class="bottom-nav" aria-label="Primary">
  @for (tab of tabs(); track tab.route) {
    <a
      class="bottom-nav-link"
      [routerLink]="tab.route"
      routerLinkActive="bottom-nav-link--active"
      [attr.aria-label]="tab.label"
    >
      <span class="bottom-nav-icon-wrap">
        <app-icon [name]="tab.icon" [size]="20" aria-hidden="true" />
        @if (tab.route === '/profile' && showProfileDot()) {
          <span class="bottom-nav-dot" aria-hidden="true"></span>
        }
      </span>
      <span class="bottom-nav-label">{{ tab.label }}</span>
    </a>
  }
</nav>
